export default __webpack_public_path__ + "static/imgModalNoCover-5b86a10b99249ea9b2ca05679f337c2a.png";